import * as Yup from 'yup';
import { nameSchema } from './fieldSchemas';

export const NewHospitalSchema = Yup.object().shape({
  hospitalName: nameSchema({
    required: true,
    requiredMessage: 'Hastane adı zorunludur',
  }).min(2, 'Hastane adı en az 2 karakter olmalıdır'),
  hospitalAddress: Yup.string(),
});
